import { BasketRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { SetBasketType } from "@utilities/types";

export const basketService = {
    setBasket: async (basketData: Partial<SetBasketType>) => {
        return await fetchRequest({
            route: BasketRoutesEnum.BASKET_SET_BASKET,
            method: "POST",
            data: basketData,
        });
    },

    getCollabBasket: async (collaboratorToken: string) => {
        return await fetchRequest({
            route: `${BasketRoutesEnum.BASKET_GET_COLLAB_BASKET}/${collaboratorToken}`,
            method: "GET",
        });
    },

    deleteBasket: async (basketId: string) => {
        return await fetchRequest({
            route: `${BasketRoutesEnum.BASKET_DELETE}/${basketId}`,
            method: "DELETE",
        });
    },
};
